module.exports = __webpack_public_path__ + "7d088296/img/note-list-icon.961c1485.svg";